import { withFireUiAnalytics } from '@atlassian/jira-analytics-web-react/src';
import ShareeTypePicker from './view';

export default withFireUiAnalytics({ onChange: 'pickShareeType' })(ShareeTypePicker);
export const EditorTypePicker = withFireUiAnalytics({ onChange: 'pickEditorType' })(
	ShareeTypePicker,
);
